import { PATH } from '@/router/PATH';

/**
 * The product details page's address (bos-app#119): which branch's stock its
 * figures count, as `?branch=`. The list's own key, so a list scoped to a
 * branch hands it on unchanged.
 */
const BRANCH_PARAM = 'branch';

/** The branch in the page address, or `null` for the caller's own scope. */
export const readProductDetailBranch = (
    params: URLSearchParams,
): string | null => params.get(BRANCH_PARAM)?.trim() || null;

/**
 * The page address with `branchId` as its branch, every other key kept.
 * `null` takes the branch out: the caller's own scope, All branches for an
 * OrgAdmin.
 */
export const writeProductDetailBranch = (
    params: URLSearchParams,
    branchId: string | null,
): URLSearchParams => {
    const next = new URLSearchParams(params);
    if (branchId === null) {
        next.delete(BRANCH_PARAM);
    } else {
        next.set(BRANCH_PARAM, branchId);
    }
    return next;
};

/** A product's details page, counting `branchId`'s stock when one is given. */
export const toProductDetailPath = (
    productId: string,
    branchId: string | null,
): string => {
    const path = PATH.PRODUCTS.BIND(productId);
    if (branchId === null) {
        return path;
    }
    return `${path}?${writeProductDetailBranch(new URLSearchParams(), branchId).toString()}`;
};
